import {
    LISTAR_ESTATUSORDENCOMPRAS,
} from '../../types'


export default (state, action) => {
    switch (action.type){
        case LISTAR_ESTATUSORDENCOMPRAS: 
            return{
                ...state,
                estatusOrdenCompra: action.payload
            }
        default:
            return state
    }
        
}